import {ReactNode, useCallback, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';

import {Icon, UnauthorizedLayoutContent, Button} from 'components';
import {UserContext} from 'context';
import {LogoutType} from 'enums';
import {UnauthorizedLayout} from 'layouts';
import {TRANSLATION_KEYS} from 'locale';
import {userAuthUtils} from 'utils/user-auth';

const T_KEYS = TRANSLATION_KEYS.IN_SESSION_PAGE.ENDED_VIEW;

type Props = {
    message: string;
    showOpenDefaultPageButton?: boolean;
    children?: ReactNode;
    handleOpenDefaultPage?: () => void;
};

export const ErrorPage: React.FC<Props> = ({message, showOpenDefaultPageButton, children, handleOpenDefaultPage}: Props) => {
    const {t} = useTranslation();
    const userContext = useContext(UserContext);
    const history = useHistory();

    const openDefaultPage = useCallback(() => {
        handleOpenDefaultPage?.();

        if (userContext?.auth?.sessionAccessOnly) {
            userAuthUtils.logout(LogoutType.SessionTokenExpired);
        } else {
            history.push('/');
        }
    }, [handleOpenDefaultPage, userContext, history]);

    return (
        <UnauthorizedLayout>
            <UnauthorizedLayoutContent title={message} highlight={false} titlePosition='before'>
                <Icon name='x-circle' size='8xl' color='alert' thickness='sm' className='tw-mx-auto tw-order-first tw-mb-8' />
                {children}
                {showOpenDefaultPageButton &&
                    <Button
                        color='primary'
                        width='large'
                        rounded
                        className='tw-ts-h5 tw-mt-10 tw-mx-auto'
                        onClick={openDefaultPage}
                    >
                        {t(T_KEYS.MAIN_PAGE_BTN)}
                    </Button>}
            </UnauthorizedLayoutContent>
        </UnauthorizedLayout>
    );

};